import type { FormikErrors } from "formik";
import type { RefObject } from "react";

import { showValidationErrors } from "@utils";
import { useTranslateErrorObj } from "@/hooks/useTranslateErrorObj";

export function useNotifyValidateForm<T>(
  validateForm?: () => Promise<FormikErrors<T>>,
  formRef?: RefObject<HTMLElement>,
) {
  const { getTranslatedObj } = useTranslateErrorObj();

  const notifyValidateForm = () => {
    validateForm?.().then((errors) => {
      const keys = Object.keys(errors);

      if (!keys || keys.length === 0) return;
      const input = formRef?.current?.querySelector(`label[for="${keys[0]}"]`);

      input?.scrollIntoView({ behavior: "smooth" });
      const errorObjTranslation = getTranslatedObj(errors);

      showValidationErrors(errorObjTranslation);
    });
  };

  return { notifyValidateForm };
}
